import React from "react";
import PageBox from "../../layout/PageBox";
import { MyColor } from "../../config/myStyle";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { Trans, useTranslation } from "react-i18next";
import heartLouderIcon from "../../imgs/host_a_fundraiser_page_heart_louder_icon@2x.png";
import heartBulbIcon from "../../imgs/host_a_fundraiser_page_heart_light_bulb_icon@2x.png";
import donationIcon from "../../imgs/afd_donation_icon@2x.png";

const stepKeys = ["step_1", "step_2", "step_3"] as const;
const stepIcons = [heartLouderIcon, heartBulbIcon, donationIcon];

const CampaignCreateIntro = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PageBox spinning={false}>
      <div className="px-[20px] pt-[20px] pb-[40px]">
        <div
          className="text-center text-[24px] font-[600] leading-[1.4]"
          style={{ color: MyColor.blue }}
        >
          {t("campaign_create_intro.title")}
        </div>

        <div className="mt-[24px] px-[6px]">
          {/* 这里改为竖向信息块版式，并复用项目内现有 icon 素材。 */}
          <div className="space-y-[34px]">
            {stepKeys.map((stepKey, index) => (
              <div key={stepKey} className="text-center">
                <img
                  src={stepIcons[index]}
                  alt={t(`campaign_create_intro.${stepKey}_title`)}
                  className="mx-auto h-[136px] w-auto object-contain"
                />
                <div
                  className="mt-[16px] text-[27px] font-[700] leading-[1.2]"
                  style={{ color: MyColor.blue }}
                >
                  {t(`campaign_create_intro.${stepKey}_title`)}
                </div>
                <div
                  className="mx-auto mt-[12px] max-w-[312px] text-[15px] leading-[1.85]"
                  style={{ color: "rgba(20, 31, 90, 0.78)" }}
                >
                  {t(`campaign_create_intro.${stepKey}_body`)}
                </div>
              </div>
            ))}
          </div>

          <div
            className="mx-auto mt-[34px] max-w-[620px] text-center text-[20px] leading-[1.75]"
            style={{ color: MyColor.blue, fontWeight: 500 }}
          >
            {/* 专页词组作为不可拆分片段，其他文字仍按屏幕自然换行。 */}
            <Trans i18nKey="campaign_create_intro.cta_text" components={{ page: <span className="whitespace-nowrap" /> }} />
          </div>

          <div className="mt-[22px] flex justify-center">
            <Button
              type="primary"
              htmlType="button"
              style={{
                borderRadius: 999,
                background: "#C8A16A",
                borderColor: "#C8A16A",
                height: 52,
                minWidth: 176,
                fontSize: 18,
                color: "white",
                fontWeight: 600,
                paddingInline: 30,
                boxShadow: "0 10px 20px rgba(200, 161, 106, 0.24)",
              }}
              // 这里保留原有 CTA 跳转逻辑，不改业务行为。
              onClick={() => navigate("/campaign/create/select-type")}
            >
              {t("campaign_create_intro.create_fundraising_page")}
            </Button>
          </div>
        </div>
      </div>
    </PageBox>
  );
};

export default CampaignCreateIntro;
